import { i18n } from '@/plugins/i18n';
const COUNTRIES = [
    'Afganistán',
    'Albania',
    'Alemania',
    'Andorra',
    'Angola',
    'Antigua y Barbuda',
    'Arabia Saudita',
    'Argelia',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaiyán',
    'Bahamas',
    'Bangladés',
    'Barbados',
    'Baréin',
    'Bélgica',
    'Belice',
    'Benín',
    'Bielorrusia',
    'Birmania',
    'Bolivia',
    'Bosnia y Herzegovina',
    'Botsuana',
    'Brasil',
    'Brunéi',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Bután',
    'Cabo Verde',
    'Camboya',
    'Camerún',
    'Canadá',
    'Catar',
    'Chad',
    'Chile',
    'China',
    'Chipre',
    'Ciudad del Vaticano',
    'Colombia',
    'Comoras',
    'Corea del Norte',
    'Corea del Sur',
    'Costa de Marfil',
    'Costa Rica',
    'Croacia',
    'Cuba',
    'Dinamarca',
    'Dominica',
    'Ecuador',
    'Egipto',
    'El Salvador',
    'Emiratos Árabes Unidos',
    'Eritrea',
    'Eslovaquia',
    'Eslovenia',
    'España',
    'Estados Unidos',
    'Estonia',
    'Etiopía',
    'Filipinas',
    'Finlandia',
    'Fiyi',
    'Francia',
    'Gabón',
    'Gambia',
    'Georgia',
    'Ghana',
    'Granada',
    'Grecia',
    'Guatemala',
    'Guyana',
    'Guinea',
    'Guinea ecuatorial',
    'Guinea-Bisáu',
    'Haití',
    'Honduras',
    'Hungría',
    'India',
    'Indonesia',
    'Irak',
    'Irán',
    'Irlanda',
    'Islandia',
    'Islas Marshall',
    'Islas Salomón',
    'Israel',
    'Italia',
    'Jamaica',
    'Japón',
    'Jordania',
    'Kazajistán',
    'Kenia',
    'Kirguistán',
    'Kiribati',
    'Kuwait',
    'Laos',
    'Lesoto',
    'Letonia',
    'Líbano',
    'Liberia',
    'Libia',
    'Liechtenstein',
    'Lituania',
    'Luxemburgo',
    'Madagascar',
    'Malasia',
    'Malaui',
    'Maldivas',
    'Malí',
    'Malta',
    'Marruecos',
    'Mauricio',
    'Mauritania',
    'México',
    'Micronesia',
    'Moldavia',
    'Mónaco',
    'Mongolia',
    'Montenegro',
    'Mozambique',
    'Namibia',
    'Nauru',
    'Nepal',
    'Nicaragua',
    'Níger',
    'Nigeria',
    'Noruega',
    'Nueva Zelanda',
    'Omán',
    'Países Bajos',
    'Pakistán',
    'Palaos',
    'Panamá',
    'Papúa Nueva Guinea',
    'Paraguay',
    'Perú',
    'Polonia',
    'Portugal',
    'Reino Unido',
    'República Centroafricana',
    'República Checa',
    'República de Macedonia',
    'República del Congo',
    'República Democrática del Congo',
    'República Dominicana',
    'República Sudafricana',
    'Ruanda',
    'Rumanía',
    'Rusia',
    'Samoa',
    'San Cristóbal y Nieves',
    'San Marino',
    'San Vicente y las Granadinas',
    'Santa Lucía',
    'Santo Tomé y Príncipe',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leona',
    'Singapur',
    'Siria',
    'Somalia',
    'Sri Lanka',
    'Suazilandia',
    'Sudán',
    'Sudán del Sur',
    'Suecia',
    'Suiza',
    'Surinam',
    'Tailandia',
    'Tanzania',
    'Tayikistán',
    'Timor Oriental',
    'Togo',
    'Tonga',
    'Trinidad y Tobago',
    'Túnez',
    'Turkmenistán',
    'Turquía',
    'Tuvalu',
    'Ucrania',
    'Uganda',
    'Uruguay',
    'Uzbekistán',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Yibuti',
    'Zambia',
    'Zimbabue'
]

const COUNTRIES_MAP = [
    {
        text: "Åland Islands",
        value: "Aland Islands"
    },
    {
        text: "Albania",
        value: "Albania"
    },
    {
        text: "Algeria",
        value: "Algeria"
    },
    {
        text: "American Samoa",
        value: "American Samoa"
    },
    {
        text: "Andorra",
        value: "Andorra"
    },
    {
        text: "Angola",
        value: "Angola"
    },
    {
        text: "Anguilla",
        value: "Anguilla"
    },
    {
        text: "Antigua and Barbuda",
        value: "Antigua and Barbuda"
    },
    {
        text: "Argentina",
        value: "Argentina"
    },
    {
        text: "Armenia",
        value: "Armenia"
    },
    {
        text: "Aruba",
        value: "Aruba"
    },
    {
        text: "Australia",
        value: "Australia"
    },
    {
        text: "Austria",
        value: "Austria"
    },
    {
        text: "Azerbaijan",
        value: "Azerbaijan"
    },
    {
        text: "Bahrain",
        value: "Bahrain"
    },
    {
        text: "Bangladesh",
        value: "Bangladesh"
    },
    {
        text: "Belarus",
        value: "Belarus"
    },
    {
        text: "Belgium",
        value: "Belgium"
    },
    {
        text: "Belize",
        value: "Belize"
    },
    {
        text: "Benin",
        value: "Benin"
    },
    {
        text: "Bermuda",
        value: "Bermuda"
    },
    {
        text: "Bhutan",
        value: "Bhutan"
    },
    {
        text: "Bolivia",
        value: "Bolivia"
    },
    {
        text: "Bonaire, Sint Eustatius and Saba",
        value: "Bonaire, Sint Eustatius and Saba"
    },
    {
        text: "Bosnia-Herzegovina",
        value: "Bosnia-Herzegovina"
    },
    {
        text: "Brazil",
        value: "Brazil"
    },
    {
        text: "British Indian Ocean Territory",
        value: "British Indian Ocean Territory"
    },
    {
        text: "Brunei Darussalam",
        value: "Brunei Darussalam"
    },
    {
        text: "Bulgaria",
        value: "BG"
    },
    {
        text: "Burundi",
        value: "Burundi"
    },
    {
        text: "Cameroon",
        value: "Cameroon"
    },
    {
        text: "Canada",
        value: "Canada"
    },
    {
        text: "Cape Verde",
        value: "Cape Verde"
    },
    {
        text: "Cayman Islands",
        value: "Cayman Islands"
    },
    {
        text: "Central African Rep",
        value: "Central African Rep"
    },
    {
        text: "Chad",
        value: "Chad"
    },
    {
        text: "Chile",
        value: "Chile"
    },
    {
        text: "China",
        value: "China"
    },
    {
        text: "Christmas Island",
        value: "Christmas Island"
    },
    {
        text: "Cocos (Keeling) Islands",
        value: "Cocos (Keeling) Islands"
    },
    {
        text: "Colombia",
        value: "Colombia"
    },
    {
        text: "Comoros",
        value: "Comoros"
    },
    {
        text: "Congo (Brazzaville)",
        value: "Congo (Brazzaville)"
    },
    {
        text: "Congo, the Democratic Republic",
        value: "Congo, the Democratic Republic"
    },
    {
        text: "Cook Islands",
        value: "Cook Islands"
    },
    {
        text: "Costa Rica",
        value: "Costa Rica"
    },
    {
        text: "Cote D'Ivoire",
        value: "Cote D'Ivoire"
    },
    {
        text: "Croatia",
        value: "Croatia"
    },
    {
        text: "Cuba",
        value: "Cuba"
    },
    {
        text: "Curacao",
        value: "Curacao"
    },
    {
        text: "Cyprus",
        value: "Cyprus"
    },
    {
        text: "Czech Republic",
        value: "Czech Republic"
    },
    {
        text: "Denmark",
        value: "Denmark"
    },
    {
        text: "Djibouti",
        value: "Djibouti"
    },
    {
        text: "Dominica",
        value: "Dominica"
    },
    {
        text: "Dominican Republic",
        value: "Dominican Republic"
    },
    {
        text: "Ecuador",
        value: "Ecuador"
    },
    {
        text: "Egypt",
        value: "Egypt"
    },
    {
        text: "El Salvador",
        value: "El Salvador"
    },
    {
        text: "Equatorial Guinea",
        value: "Equatorial Guinea"
    },
    {
        text: "Eritrea",
        value: "Eritrea"
    },
    {
        text: "Estonia",
        value: "Estonia"
    },
    {
        text: "Ethiopia",
        value: "Ethiopia"
    },
    {
        text: "Falkland Islands (Malvinas)",
        value: "Falkland Islands (Malvinas)"
    },
    {
        text: "Faroe Islands",
        value: "Faroe Islands"
    },
    {
        text: "Fiji",
        value: "Fiji"
    },
    {
        text: "Finland",
        value: "Finland"
    },
    {
        text: "France",
        value: "France"
    },
    {
        text: "French Guiana",
        value: "French Guiana"
    },
    {
        text: "French Polynesia",
        value: "French Polynesia"
    },
    {
        text: "Gabon",
        value: "Gabon"
    },
    {
        text: "Gambia",
        value: "Gambia"
    },
    {
        text: "Gaza Strip",
        value: "Gaza Strip"
    },
    {
        text: "Georgia",
        value: "Georgia"
    },
    {
        text: "Germany",
        value: "Germany"
    },
    {
        text: "Gibraltar",
        value: "Gibraltar"
    },
    {
        text: "Greece",
        value: "Greece"
    },
    {
        text: "Greenland",
        value: "Greenland"
    },
    {
        text: "Grenada",
        value: "Grenada"
    },
    {
        text: "Guadeloupe",
        value: "Guadeloupe"
    },
    {
        text: "Guam",
        value: "Guam"
    },
    {
        text: "Guatemala",
        value: "Guatemala"
    },
    {
        text: "Guernsey",
        value: "Guernsey"
    },
    {
        text: "Guinea",
        value: "Guinea"
    },
    {
        text: "Guinea-Bissau",
        value: "Guinea-Bissau"
    },
    {
        text: "Guyana",
        value: "Guyana"
    },
    {
        text: "Haiti",
        value: "Haiti"
    },
    {
        text: "Honduras",
        value: "Honduras"
    },
    {
        text: "Hong Kong",
        value: "Hong Kong"
    },
    {
        text: "Hungary",
        value: "Hungary"
    },
    {
        text: "Iceland",
        value: "Iceland"
    },
    {
        text: "India",
        value: "India"
    },
    {
        text: "Indonesia",
        value: "Indonesia"
    },
    {
        text: "Ireland",
        value: "Ireland"
    },
    {
        text: "Isle of Man",
        value: "Isle of Man"
    },
    {
        text: "Israel",
        value: "Israel"
    },
    {
        text: "Italy",
        value: "Italy"
    },
    {
        text: "Jamaica",
        value: "Jamaica"
    },
    {
        text: "Japan",
        value: "Japan"
    },
    {
        text: "Jersey",
        value: "Jersey"
    },
    {
        text: "Jordan",
        value: "Jordan"
    },
    {
        text: "Kazakhstan",
        value: "Kazakhstan"
    },
    {
        text: "Kenya",
        value: "Kenya"
    },
    {
        text: "Kiribati",
        value: "Kiribati"
    },
    {
        text: "Kosovo",
        value: "Kosovo"
    },
    {
        text: "Kuwait",
        value: "Kuwait"
    },
    {
        text: "Kyrgyzstan",
        value: "Kyrgyzstan"
    },
    {
        text: "Lao People's Democratic Republic",
        value: "Lao People's Democratic Republic"
    },
    {
        text: "Latvia",
        value: "Latvia"
    },
    {
        text: "Lebanon",
        value: "Lebanon"
    },
    {
        text: "Lesotho",
        value: "Lesotho"
    },
    {
        text: "Liberia",
        value: "Liberia"
    },
    {
        text: "Libyan",
        value: "Libyan"
    },
    {
        text: "Liechtenstein",
        value: "LILiechtenstein"
    },
    {
        text: "Lithuania",
        value: "Lithuania"
    },
    {
        text: "Luxembourg",
        value: "Luxembourg"
    },
    {
        text: "Macau",
        value: "Macau"
    },
    {
        text: "Macedonia",
        value: "Macedonia"
    },
    {
        text: "Madagascar",
        value: "Madagascar"
    },
    {
        text: "Malawi",
        value: "Malawi"
    },
    {
        text: "Malaysia",
        value: "Malaysia"
    },
    {
        text: "Maldives",
        value: "Maldives"
    },
    {
        text: "Mali",
        value: "Mali"
    },
    {
        text: "Malta",
        value: "Malta"
    },
    {
        text: "Marshall Islands",
        value: "Marshall Islands"
    },
    {
        text: "Martinique",
        value: "Martinique"
    },
    {
        text: "Mauritania",
        value: "Mauritania"
    },
    {
        text: "Mayotte",
        value: "Mayotte"
    },
    {
        text: "Mexico",
        value: "Mexico"
    },
    {
        text: "Micronesia",
        value: "Micronesia"
    },
    {
        text: "Moldova",
        value: "Moldova"
    },
    {
        text: "Monaco",
        value: "Monaco"
    },
    {
        text: "Mongolia",
        value: "Mongolia"
    },
    {
        text: "Montenegro",
        value: "Montenegro"
    },
    {
        text: "Montserrat",
        value: "Montserrat"
    },
    {
        text: "Mozambique",
        value: "Mozambique"
    },
    {
        text: "Namibia",
        value: "Namibia"
    },
    {
        text: "Nauru",
        value: "Nauru"
    },
    {
        text: "Nepal",
        value: "Nepal"
    },
    {
        text: "Netherlands",
        value: "Netherlands"
    },
    {
        text: "New Caledonia",
        value: "New Caledonia"
    },
    {
        text: "New Zealand",
        value: "New Zealand"
    },
    {
        text: "Niger",
        value: "Niger"
    },
    {
        text: "Nigeria",
        value: "Nigeria"
    },
    {
        text: "Niue",
        value: "Niue"
    },
    {
        text: "Norfolk Island",
        value: "Norfolk Island"
    },
    {
        text: "North Korea",
        value: "North Korea"
    },
    {
        text: "Northern Mariana Islands",
        value: "Northern Mariana Islands"
    },
    {
        text: "Norway",
        value: "Norway"
    },
    {
        text: "Oman",
        value: "Oman"
    },
    {
        text: "Palau",
        value: "Palau"
    },
    {
        text: "Papua New Guinea",
        value: "Papua New Guinea"
    },
    {
        text: "Paraguay",
        value: "Paraguay"
    },
    {
        text: "Peru",
        value: "Peru"
    },
    {
        text: "Philippines",
        value: "Philippines"
    },
    {
        text: "Pitcairn",
        value: "Pitcairn"
    },
    {
        text: "Poland",
        value: "Poland"
    },
    {
        text: "Portugal",
        value: "Portugal"
    },
    {
        text: "Puerto Rico",
        value: "Puerto Rico"
    },
    {
        text: "Qatar",
        value: "Qatar"
    },
    {
        text: "Réunion",
        value: "Réunion"
    },
    {
        text: "Romania",
        value: "Romania"
    },
    {
        text: "Russian Federation",
        value: "Russian Federation"
    },
    {
        text: "Rwanda",
        value: "Rwanda"
    },
    {
        text: "Saint Barthélemy",
        value: "Saint Barthélemy"
    },
    {
        text: "Saint Helena, Ascension and Trista",
        value: "Saint Helena, Ascension and Trista"
    },
    {
        text: "Saint Martin (French part)",
        value: "Saint Martin (French part)"
    },
    {
        text: "Saint Pierre and Miquelon",
        value: "Saint Pierre and Miquelon"
    },
    {
        text: "Samoa",
        value: "Samoa"
    },
    {
        text: "San Marino",
        value: "San Marino"
    },
    {
        text: "Sao Tome & Prin.",
        value: "Sao Tome & Prin."
    },
    {
        text: "Saudi Arabia",
        value: "Saudi Arabia"
    },
    {
        text: "Senegal",
        value: "Senegal"
    },
    {
        text: "Serbia",
        value: "Serbia"
    },
    {
        text: "Seychelles",
        value: "Seychelles"
    },
    {
        text: "Sierra Leone",
        value: "Sierra Leone"
    },
    {
        text: "Singapore",
        value: "Singapore"
    },
    {
        text: "Slovakia",
        value: "Slovakia"
    },
    {
        text: "Slovenia",
        value: "Slovenia"
    },
    {
        text: "Solomon Islands",
        value: "Solomon Islands"
    },
    {
        text: "Somalia",
        value: "Somalia"
    },
    {
        text: "South Africa",
        value: "South Africa"
    },
    {
        text: "South Korea",
        value: "South Korea"
    },
    {
        text: "South Sudan",
        value: "South Sudan"
    },
    {
        text: "Spain",
        value: "Spain"
    },
    {
        text: "Sri Lanka",
        value: "Sri Lanka"
    },
    {
        text: "St Kitts & Nevis",
        value: "St Kitts & Nevis"
    }, {
        text: "St Lucia",
        value: "St Lucia"
    },
    {
        text: "St Maarten",
        value: "St Maarten"
    }, {
        text: "St Vincent & Gren",
        value: "St Vincent & Gren"
    },
    {
        text: "Sudan",
        value: "Sudan"
    },
    {
        text: "Suriname",
        value: "Suriname"
    },
    {
        text: "Svalbard and Mayen",
        value: "Svalbard and Mayen"
    },
    {
        text: "Swaziland (Eswatini)",
        value: "Swaziland (Eswatini)"
    },
    {
        text: "Sweden",
        value: "Sweden"
    },
    {
        text: "Switzerland",
        value: "Switzerland"
    },
    {
        text: "Taiwan",
        value: "Taiwan"
    },
    {
        text: "Tayikistan",
        value: "Tayikistan"
    },
    {
        text: "Tanzania",
        value: "Tanzania"
    },
    {
        text: "Thailand",
        value: "Thailand"
    },
    {
        text: "Timor-Leste",
        value: "Timor-Leste"
    },
    {
        text: "Togo",
        value: "Togo"
    },
    {
        text: "Tokelau",
        value: "Tokelau"
    },
    {
        text: "Tonga",
        value: "Tonga"
    },
    {
        text: "Tunisia",
        value: "Tunisia"
    },
    {
        text: "Turkey",
        value: "Turkey"
    },
    {
        text: "Turkmenistan",
        value: "Turkmenistan"
    },
    {
        text: "Turks and Caicos Islands",
        value: "TC"
    },
    {
        text: "Turks & Caicos",
        value: "Turks & Caicos"
    },
    {
        text: "Tuvalu",
        value: "Tuvalu"
    },
    {
        text: "Ukraine",
        value: "Ukraine"
    },
    {
        text: "United Arab Emirates",
        value: "United Arab Emirates"
    },
    {
        text: "United Kingdom",
        value: "United Kingdom"
    },
    // {
    //     text: "United States",
    //     value: "United States"
    // },
    {
        text: "United States Virgin Islands",
        value: "United States Virgin Islands"
    },
    {
        text: "Uruguay",
        value: "Uruguay"
    },
    {
        text: "Uzbekistan",
        value: "Uzbekistan"
    },
    {
        text: "Vatican City State (Holy See)",
        value: "Vatican City State (Holy See)"
    },
    {
        text: "Venezuela",
        value: "Venezuela"
    },
    {
        text: "Vietnam",
        value: "Vietnam"
    },
    {
        text: "Wallis and Futuna",
        value: "Wallis and Futuna"
    },
    {
        text: "West Bank (Palestinian Territory, O",
        value: "West Bank (Palestinian Territory, O"
    },
    {
        text: "Western Sahara",
        value: "Western Sahara"
    },
    {
        text: "Zambia",
        value: "Zambia"
    }
]

const NAL_OPTIONS = [
    {
        text: 'Afghan',
        value: 'Afghan'
    },
    {
        text: 'Albanian',
        value: 'Albanian'
    },
    {
        text: 'Algerian',
        value: 'Algerian'
    },
    {
        text: 'American',
        value: 'American'
    },
    {
        text: 'Andorran',
        value: 'Andorran'
    },
    {
        text: 'Angolan',
        value: 'Angolan'
    },
    {
        text: 'Antiguans',
        value: 'Antiguans'
    },
    {
        text: 'Argentinean',
        value: 'Argentinean'
    },
    {
        text: 'Armenian',
        value: 'Armenian'
    },
    {
        text: 'Australian',
        value: 'Australian'
    },
    {
        text: 'Austrian',
        value: 'Austrian'
    },
    {
        text: 'Azerbaijani',
        value: 'Azerbaijani'
    },
    {
        text: 'Bahamian',
        value: 'Bahamian'
    },
    {
        text: 'Bahraini',
        value: 'Bahraini'
    },
    {
        text: 'Bangladeshi',
        value: 'Bangladeshi'
    },
    {
        text: 'Barbadian',
        value: 'Barbadian'
    },
    {
        text: 'Barbudans',
        value: 'Barbudans'
    },
    {
        text: 'Batswana',
        value: 'Batswana'
    },
    {
        text: 'Belarusian',
        value: 'Belarusian'
    },
    {
        text: 'Belgian',
        value: 'Belgian'
    },
    {
        text: 'Belizean',
        value: 'Belizean'
    },
    {
        text: 'Beninese',
        value: 'Beninese'
    },
    {
        text: 'Bhutanese',
        value: 'Bhutanese'
    },
    {
        text: 'Bolivian',
        value: 'Bolivian'
    },
    {
        text: 'Bosnian',
        value: 'Bosnian'
    },
    {
        text: 'Brazilian',
        value: 'Brazilian'
    },
    {
        text: 'British',
        value: 'British'
    },
    {
        text: 'Bruneian',
        value: 'Bruneian'
    },
    {
        text: 'Bulgarian',
        value: 'Bulgarian'
    },
    {
        text: 'Burkinabe',
        value: 'Burkinabe'
    },
    {
        text: 'Burmese',
        value: 'Burmese'
    },
    {
        text: 'Burundian',
        value: 'Burundian'
    },
    {
        text: 'Cambodian',
        value: 'Cambodian'
    },
    {
        text: 'Cameroonian',
        value: 'Cameroonian'
    },
    {
        text: 'Canadian',
        value: 'Canadian'
    },
    {
        text: 'Cape Verdean',
        value: 'Cape Verdean'
    },
    {
        text: 'Central African',
        value: 'Central African'
    },
    {
        text: 'Chadian',
        value: 'Chadian'
    },
    {
        text: 'Chilean',
        value: 'Chilean'
    },
    {
        text: 'Chinese',
        value: 'Chinese'
    },
    {
        text: 'Colombian',
        value: 'Colombian'
    },
    {
        text: 'Comoran',
        value: 'Comoran'
    },
    {
        text: 'Congolese',
        value: 'Congolese'
    },
    {
        text: 'Costa Rican',
        value: 'Costa Rican'
    },
    {
        text: 'Croatian',
        value: 'Croatian'
    },
    {
        text: 'Cuban',
        value: 'Cuban'
    },
    {
        text: 'Cypriot',
        value: 'Cypriot'
    },
    {
        text: 'Czech',
        value: 'Czech'
    },
    {
        text: 'Danish',
        value: 'Danish'
    },
    {
        text: 'Djibouti',
        value: 'Djibouti'
    },
    {
        text: 'Dominican',
        value: 'Dominican'
    },
    {
        text: 'Dutch',
        value: 'Dutch'
    },
    {
        text: 'East Timorese',
        value: 'East Timorese'
    },
    {
        text: 'Ecuadorean',
        value: 'Ecuadorean'
    },
    {
        text: 'Egyptian',
        value: 'Egyptian'
    },
    {
        text: 'Emirian',
        value: 'Emirian'
    },
    {
        text: 'Equatorial Guinean',
        value: 'Equatorial Guinean'
    },
    {
        text: 'Eritrean',
        value: 'Eritrean'
    },
    {
        text: 'Estonian',
        value: 'Estonian'
    },
    {
        text: 'Ethiopian',
        value: 'Ethiopian'
    },
    {
        text: 'Fijian',
        value: 'Fijian'
    },
    {
        text: 'Filipino',
        value: 'Filipino'
    },
    {
        text: 'Finnish',
        value: 'Finnish'
    },
    {
        text: 'French',
        value: 'French'
    },
    {
        text: 'Gabonese',
        value: 'Gabonese'
    },
    {
        text: 'Gambian',
        value: 'Gambian'
    },
    {
        text: 'Georgian',
        value: 'Georgian'
    },
    {
        text: 'German',
        value: 'German'
    },
    {
        text: 'Ghanaian',
        value: 'Ghanaian'
    },
    {
        text: 'Greek',
        value: 'Greek'
    },
    {
        text: 'Grenadian',
        value: 'Grenadian'
    },
    {
        text: 'Guatemalan',
        value: 'Guatemalan'
    },
    {
        text: 'Guinea-Bissauan',
        value: 'Guinea-Bissauan'
    },
    {
        text: 'Guinean',
        value: 'Guinean'
    },
    {
        text: 'Guyanese',
        value: 'Guyanese'
    },
    {
        text: 'Haitian',
        value: 'Haitian'
    },
    {
        text: 'Herzegovinian',
        value: 'Herzegovinian'
    },
    {
        text: 'Honduran',
        value: 'Honduran'
    },
    {
        text: 'Hungarian',
        value: 'Hungarian'
    },
    {
        text: 'I-Kiribati',
        value: 'I-Kiribati'
    },
    {
        text: 'Icelander',
        value: 'Icelander'
    },
    {
        text: 'Indian',
        value: 'Indian'
    },
    {
        text: 'Indonesian',
        value: 'Indonesian'
    },
    {
        text: 'Iranian',
        value: 'Iranian'
    },
    {
        text: 'Iraqi',
        value: 'Iraqi'
    },
    {
        text: 'Irish',
        value: 'Irish'
    },
    {
        text: 'Israeli',
        value: 'Israeli'
    },
    {
        text: 'Italian',
        value: 'Italian'
    },
    {
        text: 'Ivorian',
        value: 'Ivorian'
    },
    {
        text: 'Jamaican',
        value: 'Jamaican'
    },
    {
        text: 'Japanese',
        value: 'Japanese'
    },
    {
        text: 'Jordanian',
        value: 'Jordanian'
    },
    {
        text: 'Kazakhstani',
        value: 'Kazakhstani'
    },
    {
        text: 'Kenyan',
        value: 'Kenyan'
    },
    {
        text: 'Kittian and Nevisian',
        value: 'Kittian and Nevisian'
    },
    {
        text: 'Kuwaiti',
        value: 'Kuwaiti'
    },
    {
        text: 'Kyrgyz',
        value: 'Kyrgyz'
    },
    {
        text: 'Laotian',
        value: 'Laotian'
    },
    {
        text: 'Latvian',
        value: 'Latvian'
    },
    {
        text: 'Lebanese',
        value: 'Lebanese'
    },
    {
        text: 'Liberian',
        value: 'Liberian'
    },
    {
        text: 'Libyan',
        value: 'Libyan'
    },
    {
        text: 'Liechtensteiner',
        value: 'Liechtensteiner'
    },
    {
        text: 'Lithuanian',
        value: 'Lithuanian'
    },
    {
        text: 'Luxembourger',
        value: 'Luxembourger'
    },
    {
        text: 'Macedonian',
        value: 'Macedonian'
    },
    {
        text: 'Malagasy',
        value: 'Malagasy'
    },
    {
        text: 'Malawian',
        value: 'Malawian'
    },
    {
        text: 'Malaysian',
        value: 'Malaysian'
    },
    {
        text: 'Maldivan',
        value: 'Maldivan'
    },
    {
        text: 'Malian',
        value: 'Malian'
    },
    {
        text: 'Maltese',
        value: 'Maltese'
    },
    {
        text: 'Marshallese',
        value: 'Marshallese'
    },
    {
        text: 'Mauritanian',
        value: 'Mauritanian'
    },
    {
        text: 'Mauritian',
        value: 'Mauritian'
    },
    {
        text: 'Mexican',
        value: 'Mexican'
    },
    {
        text: 'Micronesian',
        value: 'Micronesian'
    },
    {
        text: 'Moldovan',
        value: 'Moldovan'
    },
    {
        text: 'Monacan',
        value: 'Monacan'
    },
    {
        text: 'Mongolian',
        value: 'Mongolian'
    },
    {
        text: 'Moroccan',
        value: 'Moroccan'
    },
    {
        text: 'Mosotho',
        value: 'Mosotho'
    },
    {
        text: 'Motswana',
        value: 'Motswana'
    },
    {
        text: 'Mozambican',
        value: 'Mozambican'
    },
    {
        text: 'Namibian',
        value: 'Namibian'
    },
    {
        text: 'Nauruan',
        value: 'Nauruan'
    },
    {
        text: 'Nepalese',
        value: 'Nepalese'
    },
    {
        text: 'New Zealander',
        value: 'New Zealander'
    },
    {
        text: 'Nicaraguan',
        value: 'Nicaraguan'
    },
    {
        text: 'Nigerian',
        value: 'Nigerian'
    },
    {
        text: 'Nigerien',
        value: 'Nigerien'
    },
    {
        text: 'North Korean',
        value: 'North Korean'
    },
    {
        text: 'Northern Irish',
        value: 'Northern Irish'
    },
    {
        text: 'Norwegian',
        value: 'Norwegian'
    },
    {
        text: 'Omani',
        value: 'Omani'
    },
    {
        text: 'Pakistani',
        value: 'Pakistani'
    },
    {
        text: 'Palauan',
        value: 'Palauan'
    },
    {
        text: 'Panamanian',
        value: 'Panamanian'
    },
    {
        text: 'Papua New Guinean',
        value: 'Papua New Guinean'
    },
    {
        text: 'Paraguayan',
        value: 'Paraguayan'
    },
    {
        text: 'Peruvian',
        value: 'Peruvian'
    },
    {
        text: 'Polish',
        value: 'Polish'
    },
    {
        text: 'Portuguese',
        value: 'Portuguese'
    },
    {
        text: 'Qatari',
        value: 'Qatari'
    },
    {
        text: 'Romanian',
        value: 'Romanian'
    },
    {
        text: 'Russian',
        value: 'Russian'
    },
    {
        text: 'Rwandan',
        value: 'Rwandan'
    },
    {
        text: 'Saint Lucian',
        value: 'Saint Lucian'
    },
    {
        text: 'Salvadoran',
        value: 'Salvadoran'
    },
    {
        text: 'Samoan',
        value: 'Samoan'
    },
    {
        text: 'San Marinese',
        value: 'San Marinese'
    },
    {
        text: 'Sao Tomean',
        value: 'Sao Tomean'
    },
    {
        text: 'Saudi',
        value: 'Saudi'
    },
    {
        text: 'Scottish',
        value: 'Scottish'
    },
    {
        text: 'Senegalese',
        value: 'Senegalese'
    },
    {
        text: 'Serbian',
        value: 'Serbian'
    },
    {
        text: 'Seychellois',
        value: 'Seychellois'
    },
    {
        text: 'Sierra Leonean',
        value: 'Sierra Leonean'
    },
    {
        text: 'Singaporean',
        value: 'Singaporean'
    },
    {
        text: 'Slovakian',
        value: 'Slovakian'
    },
    {
        text: 'Slovenian',
        value: 'Slovenian'
    },
    {
        text: 'Solomon Islander',
        value: 'Solomon Islander'
    },
    {
        text: 'Somali',
        value: 'Somali'
    },
    {
        text: 'South African',
        value: 'South African'
    },
    {
        text: 'South Korean',
        value: 'South Korean'
    },
    {
        text: 'Spanish',
        value: 'Spanish'
    },
    {
        text: 'Sri Lankan',
        value: 'Sri Lankan'
    },
    {
        text: 'Sudanese',
        value: 'Sudanese'
    },
    {
        text: 'Surinamer',
        value: 'Surinamer'
    },
    {
        text: 'Swazi',
        value: 'Swazi'
    },
    {
        text: 'Swedish',
        value: 'Swedish'
    },
    {
        text: 'Swiss',
        value: 'Swiss'
    },
    {
        text: 'Syrian',
        value: 'Syrian'
    },
    {
        text: 'Taiwanese',
        value: 'Taiwanese'
    },
    {
        text: 'Tajik',
        value: 'Tajik'
    },
    {
        text: 'Tanzanian',
        value: 'Tanzanian'
    },
    {
        text: 'Thai',
        value: 'Thai'
    },
    {
        text: 'Togolese',
        value: 'Togolese'
    },
    {
        text: 'Tongan',
        value: 'Tongan'
    },
    {
        text: 'Trinidadian or Tobagonian',
        value: 'Trinidadian or Tobagonian'
    },
    {
        text: 'Tunisian',
        value: 'Tunisian'
    },
    {
        text: 'Turkish',
        value: 'Turkish'
    },
    {
        text: 'Tuvaluan',
        value: 'Tuvaluan'
    },
    {
        text: 'Ugandan',
        value: 'Ugandan'
    },
    {
        text: 'Ukrainian',
        value: 'Ukrainian'
    },
    {
        text: 'Uruguayan',
        value: 'Uruguayan'
    },
    {
        text: 'Uzbekistani',
        value: 'Uzbekistani'
    },
    {
        text: 'Venezuelan',
        value: 'Venezuelan'
    },
    {
        text: 'Vietnamese',
        value: 'Vietnamese'
    },
    {
        text: 'Welsh',
        value: 'Welsh'
    },
    {
        text: 'Yemenite',
        value: 'Yemenite'
    },
    {
        text: 'Zambian',
        value: 'Zambian'
    },
    {
        text: 'Zimbabwean',
        value: 'Zimbabwean'
    }
]

const PLATFORMS = [
    {
        text: 'MetaTrader 4 Forex and CFDs',
        value: 'MetaTrader 4 Forex and CFDs'
    },
    {
        text: 'MetaTrader 5 Forex and CFDs',
        value: 'MetaTrader 5 Forex and CFDs'
    },
]

const CURRENCY_OPTIONS = [
    {
        text: 'USD',
        value: 'USD'
    },
    {
        text: 'EUR',
        value: 'EUR'
    },
]

const YEARS_OF_EXPERIENCE = [
    {
        text: 'None',
        value: 'none'
    },
    {
        text: '0 - 2 Years',
        value: '0-2'
    },
    {
        text: '2 - 5 Years',
        value: '2-5'
    },
    {
        text: '5 - 10 Years',
        value: '5-10'
    },
    {
        text: 'Over 10 years',
        value: 'over-10'
    }
]

const TYPE_OF_BUSINESS = [
    {
        text: 'Corporative',
        value: 'corporative'
    },
    {
        text: 'Partnership',
        value: 'partnership'
    },
    {
        text: 'Limited',
        value: 'limited'
    },
    {
        text: 'Sole propietor',
        value: 'sole-propietor'
    }
]

const GENDER = [
    {
        text: 'Female',
        value: 'female'
    },
    {
        text: 'Male',
        value: 'male'
    },
    {
        text: 'Other',
        value: 'other'
    }
]

const MARITAL = [
    {
        text: 'Single',
        value: 'single'
    },
    {
        text: 'Married',
        value: 'married'
    }
]

const TITLE = [
    {
        text: 'Mr.',
        value: 'mr'
    },
    {
        text: 'Mrs.',
        value: 'mrs'
    }
]

const MONTHSDATE = [
    {
        text: 'January',
        value: 'january'
    },
    {
        text: 'February',
        value: 'february'
    },
    {
        text: 'March',
        value: 'march'
    },
    {
        text: 'April',
        value: 'april'
    },
    {
        text: 'May',
        value: 'may'
    },
    {
        text: 'June',
        value: 'june'
    },
    {
        text: 'Jule',
        value: 'jule'
    },
    {
        text: 'August',
        value: 'august'
    },
    {
        text: 'September',
        value: 'september'
    },
    {
        text: 'October',
        value: 'october'
    },
    {
        text: 'November',
        value: 'november'
    },
    {
        text: 'December',
        value: 'december'
    },

]

const INDUSTRY = [
    {
        text: 'Accountancy',
        value: 'Accountancy'
    },
    {
        text: 'Admin/Secretarial',
        value: 'Admin/Secretarial'
    },
    {
        text: 'Arms Trade/Defence',
        value: 'Arms Trade/Defence'
    },
    {
        text: 'Banking - Investment',
        value: 'Banking - Investment'
    },
    {
        text: 'Banking - Retail',
        value: 'Banking - Retail'
    },
    {
        text: 'Car Wash / Gas Station',
        value: 'Car Wash / Gas Station'
    },
    {
        text: 'Casino',
        value: 'Casino'
    },
    {
        text: 'Catering',
        value: 'Catering'
    },
    {
        text: 'Construction',
        value: 'Construction'
    },
    {
        text: 'Dentist',
        value: 'Dentist'
    },
    {
        text: 'Doctor',
        value: 'Doctor'
    },
    {
        text: 'Education',
        value: 'Education'
    },
    {
        text: 'Emergency Services',
        value: 'Emergency Services'
    },
    {
        text: 'Energy/Utilities',
        value: 'Energy/Utilities'
    },
    {
        text: 'Engineering',
        value: 'Engineering'
    },
    {
        text: 'Financial Advisor',
        value: 'Financial Advisor'
    },
    {
        text: 'Financial Services Other',
        value: 'Financial Services Other'
    },
    {
        text: 'Healthcare Other',
        value: 'Healthcare Other'
    },
    {
        text: 'Armed Forces',
        value: 'Armed Forces'
    },
    {
        text: 'HR',
        value: 'HR'
    },
    {
        text: 'Insurance',
        value: 'Insurance'
    },
    {
        text: 'IT',
        value: 'IT'
    },
    {
        text: 'Legal',
        value: 'Legal'
    },
    {
        text: 'Leisure',
        value: 'Leisure'
    },
    {
        text: 'Manufacturing',
        value: 'Manufacturing'
    },
    {
        text: 'Marketing',
        value: 'Marketing'
    },
    {
        text: 'Media',
        value: 'Media'
    },
    {
        text: 'Mining',
        value: 'Mining'
    },
    {
        text: 'Motor Trade',
        value: 'Motor Trade'
    },
    {
        text: 'Pharmaceuticals',
        value: 'Pharmaceuticals'
    },
    {
        text: 'Precious Metals',
        value: 'Precious Metals'
    },
    {
        text: 'Property',
        value: 'Property'
    },
    {
        text: 'Public Procurement',
        value: 'Public Procurement'
    },
    {
        text: 'Retail',
        value: 'Retail'
    },
    {
        text: 'Sales',
        value: 'Sales'
    },
    {
        text: 'Social Services',
        value: 'Social Services'
    },
    {
        text: 'Sports / Recreation',
        value: 'Sports / Recreation'
    },
    {
        text: 'Stockbroker',
        value: 'Stockbroker'
    },
    {
        text: 'Telecommunications',
        value: 'Telecommunications'
    },
    {
        text: 'Transport',
        value: 'Transport'
    },
    {
        text: 'Virtual Currencies',
        value: 'Virtual Currencies'
    },
]

const SOURCE_OF_FUNDS = [
    {
        text: 'Savings from salary',
        value: 'Savings from salary'
    },
    {
        text: 'Government aid',
        value: 'Government aid'
    },
    {
        text: 'Sale',
        value: 'Sale'
    },
    {
        text: 'Investments, dividends',
        value: 'Investments, dividends'
    },
    {
        text: 'Income from a trust',
        value: 'Income from a trust'
    },
    {
        text: 'Letting',
        value: 'Letting'
    },
    {
        text: 'Inheritance',
        value: 'Inheritance'
    },
    {
        text: 'Donation',
        value: 'Donation'
    },
    {
        text: 'Loan',
        value: 'Loan'
    },
    {
        text: 'Income from self-employment',
        value: 'Income from self-employment'
    },
    {
        text: 'Parents, partner or other',
        value: 'Parents, partner or other'
    },
    {
        text: 'Relative support',
        value: 'Relative support'
    },
    {
        text: 'Other',
        value: 'Other'
    }
]

const TYPE_OF_DOCS = [
    {
        text: 'Passport (Recomended)',
        value: 'passport'
    },
    {
        text: 'Driving License',
        value: 'driving-license'
    },
    {
        text: 'Identity Card',
        value: 'identity-card'
    },
    {
        text: 'Residence Permit',
        value: 'residence-permit'
    }
]

const PROOF_TYPES = [
    {
        text: 'Utility Bill',
        value: 'Utility Bill'
    },
    {
        text: 'Certificate of Residence',
        value: 'Certificate of Residence'
    },
    {
        text: 'Bank Statement',
        value: 'Bank Statement'
    }
]

const MTDS_CREDIT_CARDS = [
    {
        text: 'Zotapay',
        value: 'Zotapay'
    },
    {
        text: 'Ecommpay',
        value: 'Ecommpay'
    }
]

const CURRENCY_OPTIONS_WDRAW = [
    {
        text: 'USD',
        value: 'USD'
    },
    {
        text: 'EUR',
        value: 'EUR'
    },
]

const METHODS_WDRAW = [
    {
        text: 'Zotapay',
        value: 'ZOTAPAY'
    },
    {
        text: 'Ecommpay',
        value: 'ECOMMPAY'
    },
    {
        text: 'Neteller',
        value: 'NETELLER'
    },
    {
        text: 'Skrill',
        value: 'SKRILL'
    },
    {
        text: 'Bank Wire Transfer',
        value: 'WIRE'
    }
]

const PLATFORMS_LIVE_ACCOUNT = [
    {
        text: 'Tradeview MT4 Innovative Liquidity Connector',
        value: 'Tradeview MT4 Innovative Liquidity Connector'
    },
    {
        text: 'Tradeview MT5 Innovative Liquidity Connector',
        value: 'Tradeview MT5 Innovative Liquidity Connector'
    },
]

const CURRENCY_LIVE_ACCOUNT = [
    {
        text: 'USD',
        value: 'USD'
    },
    {
        text: 'EUR',
        value: 'EUR'
    },
    // {
    //     text: 'GBP',
    //     value: 'GBP'
    // }
]

const PLATFORMS_DEMO_ACCOUNT = [
    {
        text: 'MetaTrader 4',
        value: 'mt4'
    },
    {
        text: 'MetaTrader 5',
        value: 'mt5'
    }
]
const METHODS_BOOL = [
    {
        text: 'Yes',
        value: 'yes'
    },
    {
        text: 'No',
        value: 'no'
    }
]

const DEPOSIT_LIVE_ACCOUNT = [
    {
        text: '10.000',
        value: '10000'
    },
    {
        text: '50.000',
        value: '50000'
    },
    {
        text: '100.000',
        value: '100000'
    },
    {
        text: '500.000',
        value: '500000'
    },
    {
        text: '1.000.000',
        value: '1000000'
    }
]

const GROUP_DEMO_MT4 = [

    {
        text: 'ILC',
        value: 'ilc'
    }
]

const ACCOUNTS_TYPE = [
    {
        text: i18n.global.t('demoAccounts.ilc'),
        value: 'iLC'
    },

    {
        text: i18n.global.t('demoAccounts.xleverage'),
        value: 'XLeverage'
    }
]

const GROUP_DEMO_MT5 = [
    {
        text: 'Forex',
        value: 'Forex'
    },

    {
        text: 'Equities',
        value: 'Equities'
    }
]

const LAVERAGE = [
    {
        text: '1:1',
        value: '1:1'
    },
    {
        text: '1:5',
        value: '1:5'
    },
    {
        text: '1:50',
        value: '1:50'
    },
    {
        text: '1:100',
        value: '1:100'
    },
]

const CURRENCY_DEMO_ACCOUNT = [
    {
        text: 'USD',
        value: 'USD'
    },
    {
        text: 'EUR',
        value: 'EUR'
    }
]

const NATURE_BUSINESS = [
    {
        text: 'ACCOUNTANCY',
        value: 'ACCOUNTANCY'
    },
    {
        text: 'ADMIN/SECRETARIAL',
        value: 'ADMIN/SECRETARIAL'
    },
    {
        text: 'AGRICULTURE',
        value: 'AGRICULTURE'
    },
    {
        text: 'BANKING - INVESTMENT',
        value: 'BANKING - INVESTMENT'
    },
    {
        text: 'BANKING - RETAIL',
        value: 'BANKING - RETAIL'
    },
    {
        text: 'CATERING',
        value: 'CATERING'
    },
    {
        text: 'DENTIST',
        value: 'DENTIST'
    },
    {
        text: 'DOCTOR',
        value: 'DOCTOR'
    },
    {
        text: 'EDUCATION',
        value: 'EDUCATION'
    },
    {
        text: 'EMERGENCY SERVICES',
        value: 'EMERGENCY SERVICES'
    },
    {
        text: 'ENERGY/UTILITIES',
        value: 'ENERGY/UTILITIES'
    },
    {
        text: 'ENGINEERING',
        value: 'ENGINEERING'
    },
    {
        text: 'ENTERTAINMENT',
        value: 'ENTERTAINMENT'
    },
    {
        text: 'FINANCIAL ADVISOR',
        value: 'FINANCIAL ADVISOR'
    },
    {
        text: 'FINANCIAL SERVICES OTHER',
        value: 'FINANCIAL SERVICES OTHER'
    },
    {
        text: 'ARMED FORCES',
        value: 'ARMED FORCES'
    },
    {
        text: 'HR',
        value: 'HR'
    },
    {
        text: 'INSURANCE',
        value: 'INSURANCE'
    },
    {
        text: 'IT',
        value: 'IT'
    },
    {
        text: 'LEGAL',
        value: 'LEGAL'
    },
    {
        text: 'LEISURE',
        value: 'LEISURE'
    },
    {
        text: 'MANUFACTURING',
        value: 'MANUFACTURING'
    },
    {
        text: 'MARKETING',
        value: 'MARKETING'
    },
    {
        text: 'MEDIA',
        value: 'MEDIA'
    },
    {
        text: 'MOTOR TRADE',
        value: 'MOTOR TRADE'
    },
    {
        text: 'PROPERTY',
        value: 'PROPERTY'
    },
    {
        text: 'RETAIL',
        value: 'RETAIL'
    },
    {
        text: 'SALES',
        value: 'SALES'
    },
    {
        text: 'SOCIAL SERVICES',
        value: 'SOCIAL SERVICES'
    },
    {
        text: 'SPORTS / RECREATION',
        value: 'SPORTS / RECREATION'
    },
    {
        text: 'STOCKBROKER',
        value: 'STOCKBROKER'
    },
    {
        text: 'TELECOMMUNICATIONS',
        value: 'TELECOMMUNICATIONS'
    },
    {
        text: 'TRANSPORT',
        value: 'TRANSPORT'
    },
    {
        text: 'ARMS TRADE/DEFENCE',
        value: 'ARMS TRADE/DEFENCE'
    },
    {
        text: 'CAR WASH / GAS STATION',
        value: 'CAR WASH / GAS STATION'
    },
    {
        text: 'CASINO',
        value: 'CASINO'
    },
    {
        text: 'CONSTRUCTION',
        value: 'CONSTRUCTION'
    },
    {
        text: 'HEALTHCARE OTHER',
        value: 'HEALTHCARE OTHER'
    },
    {
        text: 'MINING',
        value: 'MINING'
    },
    {
        text: 'MONEY SERVICE/REMITTANCE',
        value: 'MONEY SERVICE/REMITTANCE'
    },
    {
        text: 'PHARMACEUTICALS',
        value: 'PHARMACEUTICALS'
    },
    {
        text: 'PRECIOUS METALS',
        value: 'PRECIOUS METALS'
    },
    {
        text: 'PUBLIC PROCUREMENT',
        value: 'PUBLIC PROCUREMENT'
    },
    {
        text: 'VIRTUAL CURRENCIES',
        value: 'VIRTUAL CURRENCIES'
    },
]






export {
    COUNTRIES,
    COUNTRIES_MAP,
    NAL_OPTIONS,
    PLATFORMS,
    CURRENCY_OPTIONS,
    YEARS_OF_EXPERIENCE,
    TYPE_OF_BUSINESS,
    GENDER,
    MARITAL,
    TITLE,
    MONTHSDATE,
    INDUSTRY,
    SOURCE_OF_FUNDS,
    TYPE_OF_DOCS,
    PROOF_TYPES,
    MTDS_CREDIT_CARDS,
    CURRENCY_OPTIONS_WDRAW,
    METHODS_WDRAW,
    PLATFORMS_LIVE_ACCOUNT,
    CURRENCY_LIVE_ACCOUNT,
    PLATFORMS_DEMO_ACCOUNT,
    DEPOSIT_LIVE_ACCOUNT,
    METHODS_BOOL,
    GROUP_DEMO_MT4,
    GROUP_DEMO_MT5,
    LAVERAGE,
    CURRENCY_DEMO_ACCOUNT,
    ACCOUNTS_TYPE,
    NATURE_BUSINESS
}
